export default __webpack_public_path__ + "static/media/quie-step-2.68473e3e.svg";